import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { formatPhone } from '@rad/utility/formatting';
import { navigate, requireToken } from '../../../utility/general';
import { useCRMStatus, isCRMMessagingAvailable } from '../../../http/crm';
import { findOrCreateConversation, clientToConversationSeed } from '../../../http/crm/conversations';
import IconButton from '../button.icon';
import Button from '../button';
import CModal from '../modal';
const SMS_CAPABLE_SUBKINDS = ['mobile', 'unknown'];
const phoneLabel = (c) => {
    const subkindTag = c.subkind !== 'unknown' ? ` (${c.subkind})` : '';
    const nameTag = c.label ? ` - ${c.label}` : '';
    return `${formatPhone(c.value)}${subkindTag}${nameTag}`;
};
export default (props) => {
    const token = requireToken('merchant');
    const status = useCRMStatus(token.merchant.id);
    const [pickerOpen, setPickerOpen] = React.useState(false);
    if (!isCRMMessagingAvailable(status)) {
        return null;
    }
    const smsPhones = props.client.contacts.filter((c) => c.kind === 'phone' && SMS_CAPABLE_SUBKINDS.includes(c.subkind));
    const anyPhone = props.client.contacts.find((c) => c.kind === 'phone');
    const disabled = !anyPhone;
    const title = disabled ? 'No phone number on file for this customer' : 'Send SMS';
    const openConversationFor = (phoneValue) => {
        const name = `${props.client.firstname} ${props.client.lastname}`.trim() || '(unnamed)';
        const initials = `${(props.client.firstname || '').charAt(0)}${(props.client.lastname || '').charAt(0)}`.toUpperCase() || '?';
        const id = findOrCreateConversation(token.merchant.id, {
            'customer_id': props.client.id,
            'customer_name': name,
            'customer_phone': formatPhone(phoneValue),
            'customer_initials': initials,
        });
        navigate(`#/crm/conversations/${id}`);
    };
    const handleClick = () => {
        if (smsPhones.length > 1) {
            setPickerOpen(true);
            return;
        }
        const seed = clientToConversationSeed(props.client);
        if (!seed) {
            return;
        }
        const id = findOrCreateConversation(token.merchant.id, seed);
        navigate(`#/crm/conversations/${id}`);
    };
    const trigger = props.labeled
        ? _jsxs(Button, { color: "secondary", ms: 1, onClick: handleClick, disabled: disabled, title: title, children: [_jsx("i", { className: "material-symbols-outlined align-middle", style: { 'fontSize': 'inherit', 'marginRight': '4px' }, children: "chat" }), "Send SMS"] })
        : _jsx(IconButton, { color: "primary", title: title, onClick: handleClick, disabled: disabled, children: "chat" });
    return _jsxs(_Fragment, { children: [trigger, _jsx(CModal, { visible: pickerOpen, title: "Which number?", onClose: () => setPickerOpen(false), nofooter: true, sm: true, children: _jsx("div", { className: "d-flex flex-column gap-2", children: smsPhones.map((p, i) => _jsx(Button, { color: "primary", onClick: () => { setPickerOpen(false); openConversationFor(p.value); }, children: phoneLabel(p) }, `${p.value}-${i}`)) }) })] });
};
